import { Grid } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import useApiQuery from 'lib/api/useApiQuery';
import { STATS_COUNTER } from 'stubs/stats';
import StatsWidget from 'ui/shared/stats/StatsWidget';

import DataFetchAlert from '../shared/DataFetchAlert';

const UNITS_WITHOUT_SPACE = ['s'];

// API 응답 타입 정의
interface DailyBurnFeeResponse {
  dailyBurnFee: string;
}

const NumberWidgetsList = () => {
  const { data, isPlaceholderData, isError } = useApiQuery('stats_counters', {
    queryOptions: {
      placeholderData: { counters: Array(10).fill(STATS_COUNTER) },
    },
  });

  // dailyBurnFee 상태 추가
  const [dailyBurnFee, setDailyBurnFee] = useState<string>('0');

  // 컴포넌트 마운트 시 API 호출
  useEffect(() => {
    fetch('https://konetexplorer.io/api/v3/dailyBurnFee')
      .then((res) => res.json())
      .then((res) => {
        const data = res as DailyBurnFeeResponse;
        if (data.dailyBurnFee) {
          setDailyBurnFee(Number(data.dailyBurnFee).toLocaleString(undefined, { maximumFractionDigits: 18 }));
        }
      })
      .catch((err) => console.error('Failed to fetch daily burn fee:', err));
  }, []);

  if (isError) {
    return <DataFetchAlert />;
  }

  return (
    <Grid
      gridTemplateColumns={{ base: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }}
      gridGap={4}
    >
      {data?.counters?.map(({ id, title, value, units, description }, index) => {
        let unitsStr = '';
        if (units && UNITS_WITHOUT_SPACE.includes(units)) {
          unitsStr = units;
        } else if (units) {
          unitsStr = ' ' + units;
        }

        return (
          <StatsWidget
            key={id + (isPlaceholderData ? index : '')}
            label={title && title.replace("ETH", "KONET")}
            value={`${Number(value).toLocaleString(undefined, { maximumFractionDigits: 3, notation: 'compact' })}${unitsStr && unitsStr.replace("ETH", "KONET")}`}
            isLoading={isPlaceholderData}
            hint={description && description.replace("ETH", "KONET")}
          />
        );
      })}

      <StatsWidget
        key="TotalBurnAmount"
        label="Total Burn Amount"
        value="799M KONET"
        isLoading={false}
        hint="Total Burn Amount"
      />

      <StatsWidget
        key="DailyBurnAmount (24h)"
        label="Daily Burn Amount (24h)"
        value={`${dailyBurnFee} KONET`}
        isLoading={false}
        hint="Daily Burn Amount (24h)"
      />
    </Grid>
  );
};

export default NumberWidgetsList;
